"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelTransform = void 0;
const ModelTransformControls_1 = require("./components/ModelTransformControls");
class ModelTransform {
    constructor(webgl, parentEl) {
        this.modelTransformFunctions = {
            translate: () => this.onModeChange("translate" /* TRANSLATE */),
            rotate: () => this.onModeChange("rotate" /* ROTATE */),
            scale: () => this.onModeChange("scale" /* SCALE */),
            space: () => this.onSpaceChange(),
            change: () => this.onChange(),
            flip: () => this.onFlipYZ(),
            reset: () => this.reset()
        };
        if (!parentEl) {
            throw new Error('Parent element (modelTransform) is undefined');
        }
        this.webgl = webgl;
        this.modelTransformControls = new ModelTransformControls_1.ModelTransformControls(parentEl);
        this.addEvents();
    }
    dispose() {
        var _a, _b;
        this.removeEvents();
        (_a = this.modelTransformControls) === null || _a === void 0 ? void 0 : _a.dispose();
        (_b = this.transformControls) === null || _b === void 0 ? void 0 : _b.dispose();
        delete this.modelTransformControls;
        delete this.transformControls;
        delete this.objectPositionOnDown;
        delete this.objectRotationOnDown;
        delete this.objectScaleOnDown;
    }
    addEvents() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        (_b = (_a = this.modelTransformControls) === null || _a === void 0 ? void 0 : _a.translateBtn) === null || _b === void 0 ? void 0 : _b.setEvent('click', this.modelTransformFunctions.translate);
        (_d = (_c = this.modelTransformControls) === null || _c === void 0 ? void 0 : _c.rotateBtn) === null || _d === void 0 ? void 0 : _d.setEvent('click', this.modelTransformFunctions.rotate);
        (_f = (_e = this.modelTransformControls) === null || _e === void 0 ? void 0 : _e.scaleBtn) === null || _f === void 0 ? void 0 : _f.setEvent('click', this.modelTransformFunctions.scale);
        (_h = (_g = this.modelTransformControls) === null || _g === void 0 ? void 0 : _g.spaceBtn) === null || _h === void 0 ? void 0 : _h.setEvent('click', this.modelTransformFunctions.space);
        (_k = (_j = this.modelTransformControls) === null || _j === void 0 ? void 0 : _j.flipYZBtn) === null || _k === void 0 ? void 0 : _k.setEvent('click', this.modelTransformFunctions.flip);
        (_m = (_l = this.modelTransformControls) === null || _l === void 0 ? void 0 : _l.resetBtn) === null || _m === void 0 ? void 0 : _m.setEvent('click', this.modelTransformFunctions.reset);
    }
    removeEvents() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        (_b = (_a = this.modelTransformControls) === null || _a === void 0 ? void 0 : _a.translateBtn) === null || _b === void 0 ? void 0 : _b.removeEvent('click', this.modelTransformFunctions.translate);
        (_d = (_c = this.modelTransformControls) === null || _c === void 0 ? void 0 : _c.rotateBtn) === null || _d === void 0 ? void 0 : _d.removeEvent('click', this.modelTransformFunctions.rotate);
        (_f = (_e = this.modelTransformControls) === null || _e === void 0 ? void 0 : _e.scaleBtn) === null || _f === void 0 ? void 0 : _f.removeEvent('click', this.modelTransformFunctions.scale);
        (_h = (_g = this.modelTransformControls) === null || _g === void 0 ? void 0 : _g.spaceBtn) === null || _h === void 0 ? void 0 : _h.removeEvent('click', this.modelTransformFunctions.space);
        (_k = (_j = this.modelTransformControls) === null || _j === void 0 ? void 0 : _j.flipYZBtn) === null || _k === void 0 ? void 0 : _k.removeEvent('click', this.modelTransformFunctions.flip);
    }
    reset() {
        this.webgl.modelTransformService.resetChanges();
    }
    onChange() {
        this.webgl.renderOnce();
    }
    onModeChange(modelTransformType) {
        PubSub.publish("object-transform-mode" /* OBJECT_TRANSFORM_MODE */, modelTransformType);
    }
    onSpaceChange() {
        PubSub.publish("object-transform-toggle" /* OBJECT_TRANSFORM_SPACE_TOGGLE */, null);
    }
    onFlipYZ() {
        PubSub.publish("object-transform-flip" /* OBJECT_TRANSFORM_FLIP */, null);
    }
}
exports.ModelTransform = ModelTransform;
